export interface Weighted {
  weight: number;
}

/**
 * Picks one item from a list using its `weight` as a relative probability
 * (weights don't need to sum to 1 — they're normalized here). Used by
 * SceneDirector to favor common vignettes over rare ones without special-
 * casing "rare" as a category in the selection logic itself.
 */
export function pickWeighted<T extends Weighted>(items: T[]): T | null {
  if (items.length === 0) return null;
  const total = items.reduce((sum, item) => sum + item.weight, 0);
  if (total <= 0) return null;

  let roll = Math.random() * total;
  for (const item of items) {
    roll -= item.weight;
    if (roll <= 0) return item;
  }
  return items[items.length - 1]; // floating-point fallback
}
